(function () {
    var bp = breakpoints.md;

    document.addEventListener("SearchAppCarouselCreated", function (event) {
        createCarousels();
    });   

    document.addEventListener("SearchAppCarouselDestroyed", function (event) {
        destroyCarousels();
    });

    var siemaCarousels = [];

    var destroyCarousels = function() {
          Array.prototype.forEach.call(siemaCarousels, function (el, i) {
            siemaCarousels[i].destroy();
            siemaCarousels.length = 0;
          });
    };

    var createCarousels = function() {        
        var carouselElements = document.querySelectorAll(".six-col-carousel .slides");        
        var isIe = detectIE();

        Array.prototype.forEach.call(carouselElements, function (el, i) {
            
            siemaCarousels.push(new Siema({
                selector: carouselElements[i],
                duration: 200,
                easing: 'ease-out',
                draggable: true,
                perPage: {
                    0: 1,
                    768: 2,
                    1024: 4,
                    1200: 6
                },
                offset: {
                    0: 0.1,
                    768: 0.05,
                    1200: 0.025
                },

                onInit: function () {
                    this.slideToCurrent();
                    this.addArrows();
                    this.updateArrows();
                    this.setAutoHeight(this);

                    if (isIe) {
                        let thisCarousel = this;
                        cssVars({
                            onComplete: function () {
                                thisCarousel.resizeHandler();
                                thisCarousel.setAutoHeight(this);
                            }
                        });
                    }

                    document.dispatchEvent(new Event('SearchAppCarouselInitComplete'));
                },
                onChange: function () {
                    this.updateArrows();
                    this.setAutoHeight(this);
                }
            }));
        });
    }

})();